module.exports = __webpack_public_path__ + "static/media/icon-play.558278af.svg";